<template>
  <v-dialog persistent max-width="600" v-model="visible"  @keydown.esc="close">
    <v-card :loading="loading">
      <v-card-title v-if="storeName">编辑店铺</v-card-title>
      <v-card-title v-else>新增店铺</v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field label="店铺名称" :disabled="loading" :rules="rules.required" v-model="store.name"/>
          <group-selector v-model="store.groupName" :rules="rules.required"/>
          <v-select label="由哪个店铺拉取数据" :item-text="getFormatterParentName" item-value="name"
                    :disabled="loading" :items="parents" v-model="store.parent">
            <!--<template v-slot:append-outer>
              <v-btn color="primary" small @click.stop="auth">{{ load.authLoading ? "认证中" : "认证" }}</v-btn>
            </template>-->
          </v-select>
          <v-text-field v-if="!store.parent" label="Application ID" :disabled="loading" :rules="rules.required" v-model="store.appId"/>
          <v-text-field v-if="!store.parent" label="Client ID" :disabled="loading" :rules="rules.required" v-model="store.clientId"/>
          <v-text-field v-if="!store.parent" label="Client Secret" :disabled="loading" :rules="rules.required" v-model="store.clientSecret"/>
          <v-text-field v-if="!store.parent" label="Refresh Token" :disabled="loading" :rules="rules.required" v-model="store.refreshToken"/>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="warning" :disabled="loading" @click="reset">重置</v-btn>
        <v-spacer/>
        <v-btn v-if="checkAuth()" text color="primary" :loading="loading" @click="save">保存</v-btn>
        <v-btn v-else text color="primary" :loading="loading" @click="auth">认证</v-btn>
        <v-btn text color="gery" @click="close">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GroupSelector from "@/components/GroupSelector";
export default {
  name: "StoreEditor",
  components: {GroupSelector},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    storeName: String
  }, computed: {
    loading() {
      return this.load.dataLoading || this.load.groupNameLoading || this.load.parentLoading || this.load.authLoading;
    }
  }, data() {
    return {
      load: {},
      parents: [],
      store: this.reset(),
      checkAuthTimer: null,
      rules: {
        required: [
            v => !!v || "该项不得为空"
        ]
      }
    }
  }, methods: {
    getData() {
      this.load.dataLoading = true;
      this.$axios.get("/store/" + this.storeName).then(
          response => {
            if (response && response.data) {
              this.load.dataLoading = false;
              this.store = response.data;
              console.log("data: ", this.store);
            }
          }
      );
    },
    getUnassignedStores() {
      this.load.parentLoading = true;
      this.$axios.get("/stores/unassigned").then(
          response => {
            this.load.parentLoading = false;
            if (response && response.data) {
              this.parents = this.parents.concat(response.data);
              console.log(this.parents);
            }
          }
      );
    }, save() {

    }, reset() {
      this.load = {
          dataLoading: false,
          groupNameLoading: false,
          parentLoading: false,
          authLoading: false,
      };
      this.parents = [{name: null, children: 0}];

      this.store = {
        name: this.storeName,
        groupName: null,
        marketCode: null,
        parent: null,
        disabled: false,
        clientId: null,
        clientSecret: null,
        refreshToken: null,
        appId: null,
        state: null,
        timeDiff: null
      };
      return this.store;
    }, close() {
      this.$emit("update:visible", false);
    }, auth() {
      let formData = new FormData();
      formData.append("storeName", this.storeName);
      formData.append("parent", this.store.parent);

      this.load.authLoading = true;
      this.$axios.post("/store/auth", formData).then(
          response => {
            console.log(response.data);
            window.open(response.data, "_blank");
            this.checkAuthTimer = setInterval(this.checkAuthResult, 10 * 1000);
          }
      );
    }, getFormatterParentName(parent) {
      return parent.name ? this.$format("{} ({})", parent.name, parent.children) : "";
    }, checkAuth() {
      return !this.store.parent || (this.store.refreshToken && JSON.parse(this.store.refreshToken)[this.store.parent]);
    }, checkAuthResult() {
      this.$axios.get("/store/auth/check", {
        params: {
          storeName: this.store.name,
          parent: this.store.parent
        },
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            if (response.data) {
              this.load.authLoading = false;
              clearInterval(this.checkAuthTimer);
            }
          }
      );
    }
  }, watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.reset();
          this.getUnassignedStores();
          if (this.storeName) {
            this.getData();
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>